import React, { useEffect, useState } from "react";
import client from "@/lib/api";
import { FileText, ImageOff, Loader2, ExternalLink } from "lucide-react";

function MsgThumb({ path, contentType, filename }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);
  const isImage = (contentType || "").startsWith("image/");
  useEffect(() => {
    if (!isImage) return;
    let url;
    client.get(`/messages/attachment/${path}`, { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setSrc(url); })
      .catch(() => setFailed(true));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [path, isImage]);

  const open = async () => {
    try {
      const r = await client.get(`/messages/attachment/${path}`, { responseType: "blob" });
      const u = URL.createObjectURL(r.data);
      window.open(u, "_blank");
      setTimeout(() => URL.revokeObjectURL(u), 60000);
    } catch { /* noop */ }
  };

  if (isImage) {
    return (
      <button data-testid="msg-attachment-image" onClick={open} title={filename}
        className="w-24 h-24 border border-[#1d3252] bg-[#070f1f] overflow-hidden flex items-center justify-center rounded hover:border-[#2563EB] transition-colors">
        {failed ? <ImageOff size={18} className="text-[#4B5563]" />
          : src ? <img src={src} alt={filename} className="w-full h-full object-cover" />
          : <Loader2 size={16} className="animate-spin text-[#8299bd]" />}
      </button>
    );
  }
  return (
    <button data-testid="msg-attachment-file" onClick={open}
      className="flex items-center gap-1.5 px-2.5 py-2 border border-[#D9A441]/50 bg-[#070f1f] text-[#D9A441] text-[11px] font-mono rounded hover:bg-[#D9A441]/10 transition-colors">
      <FileText size={14} /> <span className="max-w-[140px] truncate">{filename || "File"}</span> <ExternalLink size={11} />
    </button>
  );
}

export default function MsgAttachments({ attachments }) {
  if (!attachments || attachments.length === 0) return null;
  return (
    <div data-testid="msg-attachments" className="flex flex-wrap gap-2 mt-2">
      {attachments.map((a, i) => (
        <MsgThumb key={i} path={a.path} contentType={a.content_type} filename={a.filename} />
      ))}
    </div>
  );
}
